import { v4 as uuidv4 } from "uuid";
import { RoomlayoutServiceRowValues } from "../Domain/Types/FacilityService-Roomlayout-row.types";

/**
 * creates the newly created room layout data and assembles a room layout item object
 */
export function mapNewRowToPartialRoomlayoutItem(
  values: RoomlayoutServiceRowValues
): Partial<RoomlayoutServiceRowValues> {
  const newRoomlayoutItem = {
    uid: uuidv4(),
    id: values.id,
    name: values.name,
    description: values["description"],
    picturePaths: values.picturePaths,
    layout: values.layout
  };

  return newRoomlayoutItem;
}
